import 'twin.macro';
import 'styled-components/macro';

export const TrackReviewComplete = () => (
  <div tw="max-w-sm text-white text-center">
    <h1 tw="text-4xl font-medium">Thank you!</h1>
    <p tw="text-2xl leading-snug">
      Your feedback will be shared with the content creator and used to improve this track for others.
    </p>
  </div>
);
